import { iLocalFileAPIResponse } from '../types/ILocalFile';
import { normalizePath } from './normalizePath';

export type MergeableLocalFile = iLocalFileAPIResponse & {
  isSelected?: boolean;
};

/**
 * Merge local track matcher rows by normalized file path.
 * Keeps manually added files when a later library search response omits them,
 * and preserves isSelected when either side has it set.
 */
export const mergeTrackMatchFiles = (
  ...groups: MergeableLocalFile[][]
): MergeableLocalFile[] => {
  const uniqueFileMap = new Map<string, MergeableLocalFile>();

  groups.flat().forEach((file) => {
    const normalizedPath = normalizePath(file.filePath);
    if (!normalizedPath) return;

    const normalizedFile: MergeableLocalFile = {
      ...file,
      filePath: normalizedPath,
    };
    const existingFile = uniqueFileMap.get(normalizedPath);

    if (!existingFile) {
      uniqueFileMap.set(normalizedPath, normalizedFile);
      return;
    }

    uniqueFileMap.set(normalizedPath, {
      ...existingFile,
      ...normalizedFile,
      isSelected: Boolean(existingFile.isSelected || normalizedFile.isSelected),
      match_score: normalizedFile.match_score ?? existingFile.match_score,
      detailed_scores: normalizedFile.detailed_scores ?? existingFile.detailed_scores,
      confidence: normalizedFile.confidence ?? existingFile.confidence,
      duration_ms: normalizedFile.duration_ms ?? existingFile.duration_ms,
      tags: normalizedFile.tags ?? existingFile.tags,
    });
  });

  return Array.from(uniqueFileMap.values());
};
